module.exports = __webpack_public_path__ + "img/ecart-pay-color.c3a7c18e.svg";